<h2 mat-dialog-title>Valider les heures — {{ data.name }}</h2>

<mat-dialog-content>
	<p class="subtitle">
		{{ data.periodLabel }} — le <b>temps rémunéré</b> est la seule colonne qui part en paie.
		@if (showBadged) {
			Il est pré-rempli avec le temps badgé, ou le prévu à défaut de pointage.
		} @else {
			Il est pré-rempli avec le <b>planning</b> : corrigez ici ce qui a réellement été réalisé.
		}
	</p>

	@if (rows.length === 0) {
		<div class="empty">Aucune journée travaillée ni pointée sur cette période.</div>
	} @else {
		<table class="val-grid">
			<thead>
				<tr>
					<th>Jour</th>
					<th class="num">Prévu</th>
					@if (showBadged) { <th class="num">Badgé</th> }
					<th class="num paid">Rémunéré</th>
					<th class="num">Écart</th>
					<th>Commentaire</th>
					<th class="ok">Validé</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				@for (row of rows; track row.dat) {
					<tr [class.absent]="row.absent" [class.nobadge]="row.no_badge">
						<td class="day">
							{{ dayLabel(row) }}
							<!-- Sans colonne « badgé », l'absence se signale ici : elle reste une information du jour. -->
							@if (!showBadged && row.absent) {
								<span class="tag">Absence</span>
							}
							<!-- Le salarié a dit quelque chose sur cette journée (déclaration, ou reprise d'une
									 journée déjà validée) : sans repère ici, le « tout valider » l'écraserait sans la lire. -->
							@if (row.declared) {
								<span class="tag declared" matTooltip="Heures déclarées par le salarié — à confirmer">déclaré</span>
							}
						</td>
						<td class="num muted">{{ row.planned_min ? h(row.planned_min) : '—' }}</td>
						@if (showBadged) {
							<td class="num muted">
								@if (row.absent) {
									<span class="tag">Absence</span>
								} @else if (row.no_badge) {
									<span class="tag warn" matTooltip="Journée prévue, aucun pointage enregistré">Pas de badge</span>
								} @else {
									{{ h(row.badged_min) }}
								}
							</td>
						}
						<td class="num paid">
							<input type="number" min="0" step="0.25" class="paid-input"
								[value]="paidHours(row)" (input)="onPaidHoursChange(row, $any($event.target).value)">
							<span class="unit">h</span>
						</td>
						<td class="num">
							@if (deltaLabel(row)) {
								<span [class.over]="row.delta_min > 0" [class.under]="row.delta_min < 0">{{ deltaLabel(row) }}</span>
							}
						</td>
						<td><input type="text" class="cmt" [(ngModel)]="row.comment" placeholder="Motif de l'écart…"></td>
						<td class="ok"><mat-checkbox [(ngModel)]="row.validated"></mat-checkbox></td>
						<td>
							<button mat-icon-button type="button" matTooltip="Reprendre la valeur proposée" aria-label="Reprendre la valeur proposée" (click)="onReset(row)">
								<mat-icon>restart_alt</mat-icon>
							</button>
						</td>
					</tr>
				}
			</tbody>
			<tfoot>
				<tr>
					<td>Total</td>
					<td class="num">{{ h(totals.planned_min) }}</td>
					@if (showBadged) { <td class="num">{{ h(totals.badged_min) }}</td> }
					<td class="num paid">{{ h(totals.paid_min) }}</td>
					<td colspan="4" class="counts">
						{{ totals.validated }} validée{{ totals.validated > 1 ? 's' : '' }},
						{{ totals.pending }} en attente
					</td>
				</tr>
			</tfoot>
		</table>
	}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" (click)="onCancel()">Annuler</button>
	@if (rows.length > 0) {
		<button mat-stroked-button type="button" (click)="onValidateAll()">Tout valider</button>
		<button mat-flat-button color="primary" type="button" (click)="onSave()">Enregistrer</button>
	}
</mat-dialog-actions>
